#import "../../../../../common/graphql/SecureRowLevelsEntityFields.graphql"
query PurchaseOrderSecureRowLevels {
  secureRowLevels(orderBy: SECURITY_LEVEL_ASC) {
    nodes {
      ...SecureRowLevelsEntityFields
    }
  }
}
